'use client'

import { useMemo } from 'react'

import { Avatar, Tooltip } from '@dc-shared-web/components/base'
import {
  useGetAssignmentUsers,
  useGetAssignments,
} from '@dc-shared-web/hooks/api/assignment'

export default function AssignmentPreview({
  crunchUuid,
  checklistDataUuid,
  sectionRefId,
}: {
  crunchUuid: string
  checklistDataUuid: string
  sectionRefId?: string
  className?: string
}) {
  const { data: assignments, isLoading: isLoadingAssignments } =
    useGetAssignments({
      checklist_data_uuid: checklistDataUuid,
      crunch_uuid: crunchUuid,
    })
  const { data: assignmentUsers, isLoading: isLoadingAssignmentUsers } =
    useGetAssignmentUsers(crunchUuid)

  const assignment = useMemo(
    () =>
      assignments?.find((assignment) =>
        sectionRefId
          ? assignment.section_ref_id === sectionRefId
          : !assignment.section_ref_id
      ),
    [assignments, sectionRefId]
  )
  const assignedUser = useMemo(
    () =>
      assignmentUsers?.find((user) => user.user_uuid === assignment?.user_uuid),
    [assignment, assignmentUsers]
  )

  return !isLoadingAssignments && !isLoadingAssignmentUsers && assignedUser ? (
    <Tooltip
      content={`Assigned to ${assignedUser.firstname} ${assignedUser.lastname}`}
      side='top'
      withArrow
    >
      <Avatar
        fallback={`${assignedUser.firstname.charAt(0)}${assignedUser.lastname.charAt(0)}`}
        size='sm'
        fallbackColor='blue'
      />
    </Tooltip>
  ) : null
}
